import { useState } from "react";

export interface TransportProps {
  bpm: number;
  onBpmChange: (bpm: number) => void;
  isPlaying: boolean;
  onPlay: () => void;
  onStop: () => void;
  metronomeOn?: boolean;
  onToggleMetronome?: () => void;
  presets?: { label: string; bpm: number }[];
}

export function Transport({
  bpm,
  onBpmChange,
  isPlaying,
  onPlay,
  onStop,
  metronomeOn,
  onToggleMetronome,
  presets,
}: TransportProps) {
  const [draft, setDraft] = useState(bpm);
  return (
    <div className="nsm-card flex flex-wrap items-center gap-3 p-3">
      <button
        onClick={isPlaying ? onStop : onPlay}
        className={isPlaying ? "nsm-btn-ghost" : "nsm-btn-primary"}
      >
        {isPlaying ? (
          <>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M6 6h4v12H6zM14 6h4v12h-4z" /></svg>
            Stop
          </>
        ) : (
          <>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z" /></svg>
            Play
          </>
        )}
      </button>
      {onToggleMetronome && (
        <button
          onClick={onToggleMetronome}
          className={metronomeOn ? "nsm-btn-primary" : "nsm-btn-ghost"}
          title="Metronome"
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2a1 1 0 0 1 .94.66L18 18H6L11.06 2.66A1 1 0 0 1 12 2Zm-2.5 18h5l1 2h-7l1-2Z" /></svg>
          Metronome
        </button>
      )}
      {/* Wraps on a phone: as one row (number, slider, presets) it was 411px wide and
          pushed the whole page sideways on a 390px screen. */}
      <div className="ml-auto flex flex-wrap items-center gap-2">
        <label className="text-xs uppercase tracking-wider text-nsm-dim">BPM</label>
        <input
          type="number"
          value={draft}
          onChange={(e) => setDraft(Number(e.target.value))}
          onBlur={() => onBpmChange(Math.max(30, Math.min(240, draft)))}
          className="h-9 w-20 rounded-md border border-nsm-border bg-nsm-surface px-2 text-center text-sm text-nsm-ink"
        />
        <input
          type="range"
          min={40}
          max={200}
          value={bpm}
          onChange={(e) => {
            const v = Number(e.target.value);
            setDraft(v);
            onBpmChange(v);
          }}
          className="w-32"
        />
        {presets && (
          <div className="flex flex-wrap items-center gap-1">
            {presets.map((p) => (
              <button
                key={p.label}
                onClick={() => {
                  setDraft(p.bpm);
                  onBpmChange(p.bpm);
                }}
                className="min-h-[32px] rounded-md border border-nsm-border px-2.5 py-1 text-xs text-nsm-dim hover:bg-nsm-card"
              >
                {p.label}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
